import PropTypes from 'prop-types';
import { Card, CardContent, Skeleton, Stack } from '@mui/material';

export default function AdminLoadingState({ rows = 4 }) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <Skeleton variant="text" width="32%" height={34} />
          <Skeleton variant="rounded" height={56} />
          {Array.from({ length: rows }).map((_, index) => (
            <Skeleton key={index} variant="rounded" height={48} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

AdminLoadingState.propTypes = {
  rows: PropTypes.number,
};
